<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » URL生成結果の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>URL生成結果の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/url-result.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> URL一覧
        </div>
        <div class="manual-explain">
          生成画面で選択されたフロア・展示ページURLの一覧が表示されます。<br>
          生成画面で言語選択をした場合は言語ごとのURLが追加表示されます。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>

<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of URL Generation Result
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of URL Generation Result</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_url-result.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> URL List
        </div>
        <div class="manual-explain">
          A list of floor and exhibit page URLs selected on the generation screen is displayed.<br>
          If languages were selected on the generation screen, URLs for each language will also be added.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>
